"use client";
import React from "react";
import styles from "./HtmlBlock.module.css";

/**
 * HtmlBlock component that renders HTML content.
 *
 * Example usage:
 * <HtmlBlock html="<strong>Hello</strong> world!" />
 *
 * The component registers with Builder and accepts one input:
 * - html: HTML string to be rendered.
 */
interface HtmlBlockProps {
  html: string;
}

export default function HtmlBlock({ html }: HtmlBlockProps) {
  return (
    <div className={styles.container}>
      <div className="htmlBlock" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
